import React, { useEffect, useRef, useState, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE --------------------------------
import Card from "../../../../Base/Components/Card/Card";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { toastShow } from "../../../../Base/Services/ToastService";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";

// ------------------- CONSULTAS A LA API --------------------------------
import { getLotes } from "../../../../API/MateriaPrima/MateriaPrimaRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import LotesCRUD from './LotesCRUD'
import QRCodeModal from "./QRCodeModal";


const LotesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [tipoEtiqueta, setTipoEtiqueta] = useState(null);
  const [showEtiqueta, setShowEtiqueta] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const d = await getLotes();
    setData(d);
    setLoading(false);
  };

  const columns = [
    {
      field: "IdLote",
      header: "ID",
      headerEn:"ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NoLoteInt",
      header: "NoLote Int",
      headerEn:"NoLote Int",
      hidden: userAuth.IdRol === 1,
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NoLote",
      header: "NoLote",
      headerEn:"NoLote",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",     
      filter: false, 
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn:"Vendor",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Country",
      header: "País",
      headerEn:"Country",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn:"Comment",
      className: "large",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "FechaCreacion1",
      header: "Fecha",
      headerEn:"Date",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "UserNameCreate",
      header: "Usuario Creación",
      headerEn:"User Create",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
    {
      field: "",
      Format: "SplitButton",
      filter: false,
      className: 'Xsmall',
      alignFrozen: "right",
      frozen: true,
      Botones: [
        {
          icon: "pi pi-qrcode",
          tooltip: "Etiqueta",
          tooltipOptions: {
            position: "top",
          },
          onClick: (rowData) => {
            if(rowData?.IdLote){
              if(selected.length <= 0){
                setSelected([rowData]);
              }                      
              if(selected.length > 50){
                toastShow(toast, "warn", "Advertencia", "Solo se permite seleccionar 50 lotes");
              }
              setTimeout(() => {
                setShowEtiqueta(true)
                setTipoEtiqueta(1)
              }, 500);
            }
          },
          items: [
            {
              label: "4in x 3in",
              onClick: (rowData) => {
                if(rowData?.IdLote){
                  if(selected.length <= 0){
                    setSelected([rowData]);
                  }                      
                  if(selected.length > 50){
                    toastShow(toast, "warn", "Advertencia", "Solo se permite seleccionar 50 lotes");
                  }
                  setTimeout(() => {
                    setShowEtiqueta(true)
                    setTipoEtiqueta(1)
                  }, 500);
                }
              },
            },
            {
              label: "6in x 4in",
              onClick: (rowData) => {
                if(rowData?.IdLote){
                  if(selected.length <= 0){
                    setSelected([rowData]);
                  }                      
                  if(selected.length > 50){
                    toastShow(toast, "warn", "Advertencia", "Solo se permite seleccionar 50 lotes");
                  }
                  setTimeout(() => {
                    setShowEtiqueta(true)
                    setTipoEtiqueta(2)
                  }, 500);
                }
              },
            },
            {
              label: "4in x 1in",
              onClick: (rowData) => {
                if(rowData?.IdLote){
                  if(selected.length <= 0){
                    setSelected([rowData]);
                  }                      
                  if(selected.length > 50){
                    toastShow(toast, "warn", "Advertencia", "Solo se permite seleccionar 50 lotes");
                  }
                  setTimeout(() => {
                    setShowEtiqueta(true)
                    setTipoEtiqueta(3)
                  }, 500);
                }
              },
            },
          ],
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
  };

  const onHide = () => {
    setShowDialog(false);
    setTimeout(() => {
      setSelected([])
    }, 300);
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "lotes", config.language));
    getInfo();
  }, []);


  return (
    <div
    className=" p-fluid px-4"
    style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "lotes", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

        <Dialog visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        onHide={onHide}>

        <LotesCRUD
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          modo={selected.length > 0 ? "Editar" : "Crear"}
          onHide={onHide}
          />
          </Dialog>

      {showEtiqueta && (
        <QRCodeModal
          selected={selected}
          setSelected={setSelected}
          showEtiqueta={showEtiqueta}
          setShowEtiqueta={setShowEtiqueta}
          tipoEtiqueta={tipoEtiqueta}
          setTipoEtiqueta={setTipoEtiqueta}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default LotesScreen;
